import {getErrorActionType, getSuccessActionType} from '../../../redux/utils'
import {constants} from '../../../redux/constants'
import {ComponentEnum} from '../componentsRegistry/Registry'
import {LS_EDITOR_CURRENT_QUERY} from '../constant'
import {QeSqlResultDto, TaskDto, TaskListItemDto, UserSolutionDto} from 'learndb-share'
import QueryResult from '../domain/QueryResult'
import {getStorageData} from '../../../../storage/methods'
import {IWindow} from '../domain/IWindow'

export interface ITaskState {
  task?: TaskDto
  taskError?: any
  themeTasks?: TaskListItemDto[]
  query?: string
  solution?: string
  userSolution?: UserSolutionDto
  mySolution?: string
  isExecuting?: boolean
  schemaDescription?: any
  queryResultUser?: QueryResult
  queryResultSolution?: QueryResult
  checkResults?: any
  sqlResults?: QeSqlResultDto[]
  isQueryResultEquals?: boolean
  isFullscreenMode?: boolean
  isSplitMode?: boolean
  fullscreenLeftComponentId?: ComponentEnum
  fullscreenRightComponentId?: ComponentEnum
  fullscreenActiveLeftComponentId?: ComponentEnum
  fullscreenActiveRightComponentId?: ComponentEnum

  isDrawerModalOpen?: boolean
  drawerModalComponentId?: ComponentEnum
  containerHeight?: number

  topLeftWindow?: IWindow
  bottomLeftWindow?: IWindow
  topRightWindow?: IWindow
  bottomRightWindow?: IWindow

  windowStyle?: number
}

const INITIAL_STATE: ITaskState = {
  task: null,
  taskError: null,
  themeTasks: null,
  query: getStorageData(LS_EDITOR_CURRENT_QUERY, true) || '',
  isExecuting: false,
  schemaDescription: null,
  queryResultUser: null,
  queryResultSolution: null,
  checkResults: null,
  sqlResults: null,
  isQueryResultEquals: false,

  isFullscreenMode: false,
  isSplitMode: false,
  fullscreenLeftComponentId: null,
  fullscreenRightComponentId: null,
  isDrawerModalOpen: true,
  drawerModalComponentId: ComponentEnum.theory,
  containerHeight: 0,

  topLeftWindow: {
    activeComponentId: undefined,
    isCollapsed: false,
    tab: {
      first: undefined,
      second: undefined,
      third: undefined,
    },
  },
  bottomLeftWindow: {
    activeComponentId: undefined,
    isCollapsed: false,
    tab: {
      first: undefined,
      second: undefined,
      third: undefined,
    },
  },
  topRightWindow: {
    activeComponentId: undefined,
    isCollapsed: false,
    tab: {
      first: undefined,
      second: undefined,
      third: undefined,
    },
  },
  bottomRightWindow: {
    activeComponentId: undefined,
    isCollapsed: false,
    tab: {
      first: undefined,
      second: undefined,
      third: undefined,
    },
  },

  windowStyle: 0,
}

function taskReducers(state: ITaskState = INITIAL_STATE, action): ITaskState {
  switch (action.type) {
    case constants.CLEAR_TASK_STATE: {
      return INITIAL_STATE
    }

    case constants.CLEAR_TASK_PROP: {
      return {
        ...state,
        [action.propId]: null,
      }
    }

    case constants.SET_TASK_STATE: {
      return {
        ...state,
        ...action.state,
      }
    }

    case constants.SET_WINDOW: {
      const positionKey = action.positionKey
      const level1Key = action.level1Key
      const level2Key = action.level2Key
      const level3Key = action.level3Key
      const isUnCollapse = action.isUnCollapse
      const payload = action.payload
      return {
        ...state,
        [positionKey]: {
          ...state[positionKey],
          isCollapsed: isUnCollapse ? false : state[positionKey].isCollapsed,
          [level1Key]: level2Key
            ? {
                ...state[positionKey][level1Key],
                [level2Key]: level3Key
                  ? {
                      ...state[positionKey][level1Key][level2Key],
                      [level3Key]: payload,
                    }
                  : payload,
              }
            : payload,
        },
      }
    }

    case getSuccessActionType(constants.GET_TASK): {
      return {
        ...state,
        task: action.data,
      }
    }

    case getSuccessActionType(constants.GET_API_ANSWER_VIEW): {
      return {
        ...state,
        solution: action.data.solution,
      }
    }

    case getErrorActionType(constants.GET_TASK): {
      return {
        ...state,
        taskError: action.error,
      }
    }

    case getSuccessActionType(constants.GET_API_TASK): {
      return {
        ...state,
        [action.propId]: action.data,
      }
    }

    case constants.SET_TASK_CONTAINER_HEIGHT: {
      return {
        ...state,
        containerHeight: action.height,
      }
    }

    default: {
      return state
    }
  }
}

export {taskReducers}
